<template>
    <Collapse :opened="opened">
        <template #header>
            <a
                v-if="collapsable"
                href="#"
                class="Item flex row-stretch-center"
                :class="[type]"
                @click.prevent="handleToggle"
            >
                <div class="flex row-left-center">
                    <div
                        class="Number flex col-center mr-1"
                        :class="[type]"
                    >
                        <WText
                            tag="span"
                            :size="14"
                        >
                            {{ length }}
                        </WText>
                    </div>
                    <WText
                        :size="14"
                        tag="span"
                        weight="semi"
                        uppercase
                        class="Status"
                        :class="[type]"
                    >
                        {{ $tc(`imports.create.notifications.${type}`, length, { count: length }) }}
                    </WText>
                </div>
                <WIcon
                    icon="chevron-down"
                    :size="28"
                    :class="[type]"
                />
            </a>
        </template>
        <template #default>
            <div
                v-if="length"
                class="ImportNotifications"
                :class="{ 'mt-1': collapsable }"
            >
                <Issue
                    v-for="(notification, index) in notifications"
                    :key="`notification-${index}`"
                    v-bind="notification"
                />
            </div>
        </template>
    </Collapse>
</template>

<script>
import VueTypes from 'vue-types'
import { Collapse, Issue } from '@/components'

export default {
    name: 'ImportNotifications',
    components: {
        Collapse,
        Issue,
    },
    props: {
        title: VueTypes.string,
        type: VueTypes.oneOf(['success', 'error', 'warning', 'info', '']),
        collapsable: VueTypes.bool.def(false),
        notifications: VueTypes.arrayOf(VueTypes.shape({
            type: VueTypes.string,
            level: VueTypes.string,
            scope: VueTypes.string,
            message: VueTypes.string,
            row: VueTypes.oneOfType([VueTypes.string, VueTypes.number]),
            field: VueTypes.string,
        }).loose),
    },
    data () {
        return {
            opened: !this.collapsable,
        }
    },
    computed: {
        length () {
            return (this.notifications || []).length
        },
    },
    methods: {
        handleToggle () {
            this.opened = !this.opened
        },
    },
}
</script>
<style lang="scss" scoped>
.backgrounds {
    &.success {
       background: rgba($success, .1);
    }

    &.error {
       background: rgba($danger, .1);
    }

    &.warning {
       background: rgba($warning, .1);
    }

    &.info {
        background: rgba($info, .1);
    }
}

.Item {
    padding: 15px;
    border-radius: $border-radius;
    @extend .backgrounds;

    & + & {
        margin-top: 15px;
    }
}

.Number {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    @extend .backgrounds;
}

.WText.Status, .WIcon {
    &.success {
        color: $success;
    }
    &.error {
        color: $danger;
    }
    &.warning {
        color: $warning;
    }
    &.info {
        color: $info;
    }
}
</style>
